<template>
  <section class="content">
    <header class="content__title">
      <h1>我的信息</h1>
    </header>

    <div class="card">
      <div class="card-body">
        <el-tabs @tab-click="handleTabClick" value="edit_info">
          <el-tab-pane v-loading="info_loading" name="edit_info">
            <span slot="label">
              <i class="zmdi zmdi-account-circle"></i> 我的信息
            </span>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label>用户名称</label>
                  <input type="text" class="form-control" placeholder="请输入您的名称" v-model="user_info.user_name">
                  <i class="form-group__bar"></i>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label>联系电话</label>
                  <input type="text" class="form-control" placeholder="请输入您的联系电话" v-model="user_info.contact_phone">
                  <i class="form-group__bar"></i>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label>单位名称</label>
                  <input type="text" class="form-control" placeholder="请输入您的单位名称" v-model="user_info.company_name">
                  <i class="form-group__bar"></i>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label>所属部门</label>
                  <input type="text" class="form-control" placeholder="请输入您的部门" v-model="user_info.dept">
                  <i class="form-group__bar"></i>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <label>地址</label>
                  <input type="text" class="form-control" placeholder="请输入您的地址" v-model="user_info.address">
                  <i class="form-group__bar"></i>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label>所属区域</label>
                  <div class="form-group form-group--select">
                    <div class="select">
                      <select class="form-control" v-model='user_info.area'>
                        <option v-for="option in area_options" :value='option.value'>{{option.text}}</option>
                      </select>
                    </div>
                  </div>
                  <i class="form-group__bar"></i>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <button type="button" class="btn btn-primary" v-waves @click="handleSubmit"
                          :disabled="info_loading||info_saving">
                    <template v-if="!info_saving">保存修改</template>
                    <template v-else>正在保存,请稍后...</template>
                  </button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="update_pwd">
            <span slot="label">
              <i class="zmdi zmdi-info"></i> 修改密码
            </span>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label>当前密码</label>
                  <input type="password" class="form-control" placeholder="请输入您现在的密码" v-model="old_password"
                         name="old_password">
                  <i class="form-group__bar"></i>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label>新密码</label>
                  <input type="password" class="form-control" placeholder="请输入新密码" v-model="new_password"
                         name="new_password">
                  <i class="form-group__bar"></i>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label>确认新密码</label>
                  <input type="password" class="form-control" placeholder="请再次输入新密码" v-model="confirm_new_password"
                         name="confirm_new_password">
                  <i class="form-group__bar"></i>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <button type="button" class="btn btn-primary" v-waves @click="handleChangePwd"
                          :disabled="info_saving">
                    <template v-if="!info_saving">保存修改</template>
                    <template v-else>正在保存,请稍后...</template>
                  </button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>


      </div>
    </div>
  </section>
</template>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import {logoutAndShowLogin} from '../../utils/auth';

  export default {
    components: {},
    data() {
      return {
        user_info: {
          user_name: '',
          contact_phone: '',
          company_name: '',
          area: '',
          dept: '',
          address: ''
        },
        area_options: [],
        old_password: '',
        new_password: '',
        confirm_new_password: ''
      }
    },
    computed: {
      ...mapGetters([
        'info_loading',
        'info_saving',
        'sp_id'
      ]),
    },
    methods: {
      ...mapActions([
        'fetchUserInfo',
        'saveUserInfo',
        'updatePassword',
        'fetchBindingInfo'
      ]),
      async loadInfo() {
        this.user_info = await this.fetchUserInfo();
        const {data: {areas}} = await this.fetchBindingInfo({spId: this.sp_id});
        this.area_options = areas ? areas.map(item => {
          return {text: item.name, value: item.name}
        }) : [];
      },
      handleTabClick(tab) {
        if (tab.name === 'edit_info') {
          this.loadInfo();
        }
      },
      handleSubmit() {
        if (this.user_info.user_name.trim().length === 0) {
          this.$message.error('请输入用户名称');
          return;
        }
        if (this.user_info.contact_phone.trim().length === 0) {
          this.$message.error('请输入联系电话');
          return;
        }
        this.saveUserInfo(this.user_info);
      },
      async handleChangePwd() {
        if (this.old_password.trim().length === 0) {
          this.$message.error('请输入当前密码');
          return;
        }
        if (this.new_password.trim().length === 0) {
          this.$message.error('请输入新密码');
          return;
        }
        if (this.confirm_new_password.trim() !== this.new_password.trim()) {
          this.$message.error('新密码与确认密码不匹配');
          return;
        }

        await this.updatePassword({
          old_password: this.old_password,
          new_password: this.new_password
        });
        logoutAndShowLogin();
      },
    },
    beforeCreated() {
    },
    created() {
    },
    mounted() {
      this.loadInfo();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/info.vue